import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Request-type glyphs for the "Create Request" dropdown menu, traced verbatim
 * from the Claude design (`Dashboard.dc.html` create menu). They are stroked
 * line icons (not MUI's filled `*Outlined` set), so `stroke="currentColor"`
 * lets each caller keep driving the colour — e.g. the muted "locked" tint on
 * Bulk send when the plan lacks it.
 */
const MenuGlyph = ({ children, sx, ...rest }: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.9}
    strokeLinecap="round"
    strokeLinejoin="round"
    // SvgIcon defaults to `fill: currentColor`, which would flood these
    // outline glyphs — force it back off.
    sx={{ fill: "none", ...sx }}
    {...rest}
  >
    {children}
  </SvgIcon>
);

/** "I am the only signer" — pencil. */
export const OnlySignerIcon = (props: SvgIconProps) => (
  <MenuGlyph {...props}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
  </MenuGlyph>
);

/** "Me and others" — people. */
export const MeAndOthersIcon = (props: SvgIconProps) => (
  <MenuGlyph {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </MenuGlyph>
);

/** "Bulk send" — upload into a tray. */
export const BulkSendIcon = (props: SvgIconProps) => (
  <MenuGlyph {...props}>
    <path d="M4 14a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2" />
    <path d="M12 22V10M8 14l4-4 4 4" />
  </MenuGlyph>
);
